export type SubscriptionPlanId = 'basic' | 'premium' | 'intelligence' | 'advisory';

export const SUBSCRIPTION_PLAN_LABELS: Record<SubscriptionPlanId, string> = {
  basic: 'Basic',
  premium: 'Premium',
  intelligence: 'Intelligence',
  advisory: 'Advisory',
};

/** Prefer subscription data; support accounts created before subscription enums. */
export function getSubscriptionPlanId(session: any): SubscriptionPlanId | null {
  const user = session?.data ?? session;
  const subscription = user?.subsctions ?? user?.subscription;
  const candidates = [user?.subscriptionPlan, subscription?.subscriptionPlan,
    subscription?.membershipType, user?.isUserType];
  for (const value of candidates) {
    const id = typeof value === 'string' ? value.trim().toLowerCase() : '';
    if (Object.prototype.hasOwnProperty.call(SUBSCRIPTION_PLAN_LABELS, id)) return id as SubscriptionPlanId;
  }
  return null;
}

/** Plans are ordered by entitlement, never by displayed price. */
export function isPlanDowngrade(current: SubscriptionPlanId | null, target: SubscriptionPlanId): boolean {
  const order: SubscriptionPlanId[] = ['basic', 'premium', 'intelligence', 'advisory'];
  return current !== null && order.indexOf(target) < order.indexOf(current);
}
